module.exports = __webpack_public_path__ + "static/ins3-24a8acc692c3e5842b84d154ddd7238b.png";